import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Container, Row, Col, Card, IconButton } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { ChevronDown, ChevronUp } from 'wix-ui-icons-common';
import { SaveButtonText } from './save-button-text';
import { ThemePreview } from '@src/components/theme-preview';
import { CategoriesEditors } from './categories-editors';
import { AdvancedOptionsCTA, sendBIAdvancedOptionsCTA } from '@src/context/actions/bi';

export const CookieCategoryTextsCard = translate()(({ t }: InjectedTranslateProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleShow = () => {
    if (!isOpen) {
      sendBIAdvancedOptionsCTA(AdvancedOptionsCTA.CustomizeCategoriesText);
    }
    setIsOpen(!isOpen);
  };

  const renderShowToggle = () => (
    <IconButton dataHook={DataHooks.AdvancedCategoriesToggle} skin="inverted" onClick={toggleShow}>
      {isOpen ? <ChevronUp /> : <ChevronDown />}
    </IconButton>
  );

  const renderOpenedCard = () => (
    <>
      <Card.Subheader title={t('advanced-options.categories.display.title')} />
      <Card.Content>
        <Container>
          <Row>
            <Col span={4}>
              <SaveButtonText />
            </Col>
            <Col span={8}>
              <ThemePreview skin="popup" />
            </Col>
          </Row>
        </Container>
      </Card.Content>
      <Card.Subheader title={t('advanced-options.categories.text.title')} />
      <Card.Content>
        <CategoriesEditors />
      </Card.Content>
    </>
  );

  return (
    <Container>
      <Row>
        <Col>
          <Card dataHook={DataHooks.AdvancedCategoriesContainer}>
            <Card.Header
              dataHook={DataHooks.AdvancedCategoriesHeader}
              title={t('advanced-options.categories.title')}
              subtitle={t('advanced-options.categories.subtitle')}
              suffix={renderShowToggle()}
            />
            {isOpen && renderOpenedCard()}
          </Card>
        </Col>
      </Row>
    </Container>
  );
});
